import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import { fetchBankList } from "../store/slices/bankListSlice";
import { fetchMenus } from "../store/slices/menuSlice";
import { fetchFaqs } from "../store/slices/faqSlice";
import { fetchHeroSliders } from "../store/slices/herosliderSlice";
import { fetchTestimonials } from "../store/slices/testimonialSlice";
import { fetchSubServices } from "../store/slices/subServiceSlice";
import { fetchSatisfiedCounter } from "../store/slices/satisfiedCounter";
import { fetchToast } from "../store/slices/toastSlice";
import { fetchTeam } from "../store/slices/teamSlice";
import { fetchServicesRequest } from "../store/slices/instantServicesListSlice";
import { fetchHelpServices } from "../store/slices/helpServiceSlice";
import { fetchServices } from "../store/slices/servicesSlice";
import { fetchLoanProducts } from "../store/slices/loanProductSlice";

export default function DataFetcher() {
  const dispatch = useDispatch();

  const loanFetchedRef = useRef(false);

  // =========================
  // PRIORITY LOADERS
  // =========================
  const priorityLoading = useSelector((state) => {
    return (
      state.bankList.loading ||
      state.menu.loading ||
      state.faq.loading ||
      state.heroslider.loading ||
      state.toast.loading
    );
  });

  // =========================
  // LOAN DATA EXIST CHECK
  // =========================
  const hasLoanProducts = useSelector(
    (state) => state.loanProduct?.data?.length > 0,
  );

  // =========================
  // 1. PRIORITY API CALLS
  // =========================
  useEffect(() => {
    dispatch(fetchHeroSliders());
    dispatch(fetchMenus());
    dispatch(fetchBankList());
    dispatch(fetchFaqs());
    dispatch(fetchToast());
  }, [dispatch]);

  // =========================
  // 2. OTHER API CALLS
  // =========================
  useEffect(() => {
    if (!priorityLoading) {
      dispatch(fetchTestimonials());
      dispatch(fetchSubServices());
      dispatch(fetchTeam());
      dispatch(fetchSatisfiedCounter());
      dispatch(fetchHelpServices());
      dispatch(fetchServicesRequest({ search: "" }));
      dispatch(fetchServices());
    }
  }, [priorityLoading, dispatch]);

  // =========================
  // 3. LOAN PRODUCTS LAST
  // =========================
  useEffect(() => {
    if (!priorityLoading && !loanFetchedRef.current && !hasLoanProducts) {
      loanFetchedRef.current = true;

      // delay for smoother UX
      const timer = setTimeout(() => {
        dispatch(fetchLoanProducts());
      }, 1500);

      return () => clearTimeout(timer);
    }
  }, [priorityLoading, hasLoanProducts, dispatch]);

  return null;
}
